import React from "react";
import { Container, Row, Col } from "shards-react";
import DebitNotes from "../components/invoicing/DebitNotes";

const DebitNotesView = props => {
  const { client_id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <DebitNotes client_id={client_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default DebitNotesView;
